<template>
  <div class="row">
    <div class="col-sm-6">
      <card class="stacked-form">
        <form @submit.prevent="submit">
          <fg-input label="Name" type="text" v-model="user.name"
            :error="valErrors['name'] ? valErrors['name'][0] : null" />
          <fg-input label="Email" type="email" v-model="user.email"
            :error="valErrors['email'] ? valErrors['email'][0] : null" />
          <fg-input label="Telefonnummer" type="text" v-model="user.phone"
            :error="valErrors['phone'] ? valErrors['phone'][0] : null" />
          <template v-if="warehouses.length > 1">
            <div class="form-group has-label">
              <label>Standardlager</label>
              <multiselect v-model="user.warehouse" :options="warehouses" track-by="id" label="short_name"
                placeholder="Lager auswählen" />
            </div>
          </template>
          <div class="form-group has-label">
            <label>Rolle</label>
            <multiselect v-model="user.role" :options="roles" :allow-empty="false" deselect-label="" />
          </div>
          <div class="form-group has-label" v-if="user.role === 'lageradmin' || user.role === 'user'">
            <label>Standort</label>
            <multiselect @select="onSelectLocation" v-model="selectedLocations" :options="locations" :key="locations.id"
              label="name" :multiple="true" :preserve-search="true" track-by="name" />
          </div>
          <div class="form-group has-label"
            v-if="(user.role === 'lageradmin' || user.role === 'user') && selectedLocations">
            <label>Zugriff zu dem Lager</label>
            <multiselect v-model="selectedWarehouse" :options="filteredWarehouses" :key="filteredWarehouses.id"
              :multiple="true" label="short_name" :close-on-select="false" :clear-on-select="false"
              :preserve-search="true" track-by="short_name" />
          </div>
          <div class="form-group has-label"
            v-if="(user.role === 'lageradmin' || user.role === 'user') && selectedLocations">
            <label>Kostenstellen</label>
            <multiselect v-model="selectedCostCenters" :options="cost_centers" :key="cost_centers.id" :multiple="true"
              label="name" :close-on-select="false" :clear-on-select="false" :preserve-search="true" track-by="name" />
          </div>
          <button type="submit" class="btn btn-fill btn-info">Speichern</button>
        </form>
      </card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      roles: ['frontdesk', 'user', 'lageradmin', 'admin'],
      user: {},
      valErrors: [],
      warehouses: [],
      locations: [],
      filteredWarehouses: [],
      selectedWarehouse: '',
      selectedLocations: '',
      cost_centers: [],
      selectedCostCenters: ''
    }
  },
  methods: {
    async submit() {
      await this.initCsrf()

      if (this.selectedWarehouse.length) {
        this.user.warehouse_ids = this.selectedWarehouse.map((warehouse) => warehouse.id)
      } else {
        this.user.warehouse_ids = null;
      }
      if (this.selectedLocations.length) {
        this.user.location_ids = this.selectedLocations.map((location) => location.id)
      } else {
        this.user.location_ids = null;
      }
      if (this.selectedCostCenters.length) {
        this.user.cost_center_ids = this.selectedCostCenters.map((location) => location.id)
      } else {
        this.user.cost_center_ids = null;
      }
      this.valErrors = []
      this.user.warehouse_id = this.user.warehouse ? this.user.warehouse.id : null
      this.$http.put(`/users/${this.user.id}`, this.user).then(({ data }) => {
        this.$notify({
          message: 'User erfolgreich bearbeitet.',
          type: 'success'
        })
        this.$router.push('/users')
      }).catch(({ response }) => {
        this.valErrors = response.data.errors
      })
    },
    onSelectLocation() {
      this.filteredWarehouses = this.warehouses.filter(warehouse => {
        return this.selectedLocations.some(location => location.id === warehouse.location_id);
      });
    },
  },
  created() {
    this.$http.get(`/users/${this.$route.params.id}`).then(({ data }) => {
      this.user = data

      this.$http.get(`/cost_centers`).then(({ data }) => {
        this.cost_centers = data
        if (this.user.cost_center_ids) {
          this.user.cost_center_ids = JSON.parse(this.user.cost_center_ids);
          this.selectedCostCenters = this.cost_centers.filter(cost_center => {
            return this.user.cost_center_ids.includes(cost_center.id);
          });
        }

        this.$http.get(`/locations`).then(({ data }) => {
          this.locations = data;
          if (this.user.location_ids) {
            this.user.location_ids = JSON.parse(this.user.location_ids);
            this.selectedLocations = this.locations.filter(location => {
              return this.user.location_ids.includes(location.id);
            });
          }
          this.selectedLocation = this.locations.find(location => location.id === parseInt(this.user.location_id));

          this.$http.get(`/warehouses`).then(({ data }) => {
            this.warehouses = data
            this.filteredWarehouses = this.warehouses.filter((warehouse) => {
              return warehouse.location_id === this.user.location_id;
            })

            if (this.user.warehouse_ids) {
              this.user.warehouse_ids = JSON.parse(this.user.warehouse_ids);
              this.selectedWarehouse = this.warehouses.filter(warehouse => {
                return this.user.warehouse_ids.includes(warehouse.id);
              });
            }
          });
        });
      });
    });
  },

}
</script>

<style></style>
